// extracted by mini-css-extract-plugin
export default {"main-app-tooltip":"atoms_Tooltip_main-app-tooltip__Cscy+","tooltip-text":"atoms_Tooltip_tooltip-text__dHWrK","left":"atoms_Tooltip_left__bccBc","right":"atoms_Tooltip_right__Q3xZw"};